import React, { useState, useEffect } from 'react';
import { DropdownButton, Dropdown, Accordion, Card, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Dropdown_materie = (props) => {

  const [value1, setValue1] = useState('');

  const handleSelect = (e) => {
    var lista_file = props.lista_file_mp3
    console.log(e);
    lista_file[props.index2].materia = e
    props.funzione_set_lista_file(lista_file)
    console.log(lista_file);
    props.set_funzione_aggiorna_lista(2)
  }

  function displayStarRating() {
    var stringa
    const btn = { color: "red", margin: "5%", boxShadow: "5px 5px 3px rgba(46, 46, 46, 0.62)" }

    return btn;
  }



  return (

    <DropdownButton
      variant="primary"

      title={props.lista_file_mp3[props.index2].materia}
      onSelect={handleSelect} >

      {props.lista_materie.map(function (item, index2) {
        {
          return <div>
            <Dropdown.Item eventKey={item.materia}> {item.materia} </Dropdown.Item>
          </div>
        }
      })
      }

      <Dropdown.Divider />
      <Dropdown.Item eventKey="some link">some link</Dropdown.Item>
    </DropdownButton>

  )


}


export default Dropdown_materie;

